var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"common-header-wrap"},[_c('mt-header',{staticClass:"common-header",attrs:{"title":"منذ المتجر"}},[_c('mt-button',{attrs:{"slot":"left","icon":"back"},on:{"click":function($event){return _vm.$router.go(-1)}},slot:"left"})],1)],1),_c('div',{staticClass:"common-popup-content",attrs:{"id":"my_map"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }